(function (angular) {
	'use strict';

	var featureObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			currentFeature: '<?'
		},
		controller: [
			'APP_BASE_PATH',
			'urlFactory',
			FeatureFunction
		],
		controllerAs: 'feature'
	};

	angular
		.module('featuresModule')
		.component('feature', featureObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/features/components/feature.html';
	}

	function FeatureFunction(
		APP_BASE_PATH,
		urlFactory
	) {
		var feature = this;

		feature.$onInit = function(){
			if(feature.currentFeature && feature.currentFeature.accountFeatureDetails){
				feature.principalInvested = feature.currentFeature.accountFeatureDetails.principalInvestedToDate;
				feature.upgradeThreshold = feature.currentFeature.accountFeatureDetails.upgradeThreshold;
				feature.amountNeededToUpgrade = feature.currentFeature.accountFeatureDetails.amountNeededToUpgrade;
				feature.daysWaivedForUserInvite = feature.currentFeature.accountFeatureDetails.daysWaivedForUserInvite;
				feature.currentFeature.ctaLink = urlFactory.serializeParamsAndCreateUrl(APP_BASE_PATH + feature.currentFeature.ctaLink, {
					cta: 'Account Feature'
				});
				feature.serviceLevelFeature = angular.isDefined(feature.currentFeature.accountFeatureDetails.amountNeededToUpgrade);
			}
		};
	}
})(window.angular);